// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file workspace/workspace_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { PersonalizedWorkspace, WorkspaceParticipant } from './workspace_model_pb';
import { file_workspace_workspace_model } from './workspace_model_pb';

/**
 * Describes the file workspace/workspace_responses.proto.
 */
export const file_workspace_workspace_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiN3b3Jrc3BhY2Uvd29ya3NwYWNlX3Jlc3BvbnNlcy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiXAoUR2V0V29ya3NwYWNlUmVzcG9uc2USPAoHc3VjY2VzcxgBIAEoCzIpLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkdldFdvcmtzcGFjZVN1Y2Nlc3NIAEIGCgR0eXBlIlUKE0dldFdvcmtzcGFjZVN1Y2Nlc3MSPgoJd29ya3NwYWNlGAEgASgLMisuY29tLmdlbS5iZmYuY29udHJhY3QuUGVyc29uYWxpemVkV29ya3NwYWNlImYKGUdldFdvcmtzcGFjZVVzZXJzUmVzcG9uc2USQQoHc3VjY2VzcxgBIAEoCzIuLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkdldFdvcmtzcGFjZVVzZXJzU3VjY2Vzc0gAQgYKBHR5cGUidQoYR2V0V29ya3NwYWNlVXNlcnNTdWNjZXNzEjkKBXVzZXJzGAEgAygLMiouY29tLmdlbS5iZmYuY29udHJhY3QuV29ya3NwYWNlUGFydGljaXBhbnQSEwoGY3Vyc29yGAIgASgJSACIAQFCCQoHX2N1cnNvciJwCh5TZWFyY2hVc2Vyc0luV29ya3NwYWNlUmVzcG9uc2USRgoHc3VjY2VzcxgBIAEoCzIzLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlNlYXJjaFVzZXJzSW5Xb3Jrc3BhY2VTdWNjZXNzSABCBgoEdHlwZSJ6Ch1TZWFyY2hVc2Vyc0luV29ya3NwYWNlU3VjY2VzcxI5CgV1c2VycxgBIAMoCzIqLmNvbS5nZW0uYmZmLmNvbnRyYWN0LldvcmtzcGFjZVBhcnRpY2lwYW50EhMKBmN1cnNvchgCIAEoCUgAiAEBQgkKB19jdXJzb3JCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_workspace_workspace_model]
  );

/**
 * @generated from message com.gem.bff.contract.GetWorkspaceResponse
 */
export type GetWorkspaceResponse = Message<'com.gem.bff.contract.GetWorkspaceResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetWorkspaceResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWorkspaceSuccess success = 1;
         */
        value: GetWorkspaceSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetWorkspaceResponse.
 * Use `create(GetWorkspaceResponseSchema)` to create a new message.
 */
export const GetWorkspaceResponseSchema: GenMessage<GetWorkspaceResponse> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_responses, 0);

/**
 * @generated from message com.gem.bff.contract.GetWorkspaceSuccess
 */
export type GetWorkspaceSuccess = Message<'com.gem.bff.contract.GetWorkspaceSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedWorkspace workspace = 1;
   */
  workspace?: PersonalizedWorkspace;
};

/**
 * Describes the message com.gem.bff.contract.GetWorkspaceSuccess.
 * Use `create(GetWorkspaceSuccessSchema)` to create a new message.
 */
export const GetWorkspaceSuccessSchema: GenMessage<GetWorkspaceSuccess> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_responses, 1);

/**
 * @generated from message com.gem.bff.contract.GetWorkspaceUsersResponse
 */
export type GetWorkspaceUsersResponse =
  Message<'com.gem.bff.contract.GetWorkspaceUsersResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetWorkspaceUsersResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetWorkspaceUsersSuccess success = 1;
           */
          value: GetWorkspaceUsersSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetWorkspaceUsersResponse.
 * Use `create(GetWorkspaceUsersResponseSchema)` to create a new message.
 */
export const GetWorkspaceUsersResponseSchema: GenMessage<GetWorkspaceUsersResponse> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_responses, 2);

/**
 * @generated from message com.gem.bff.contract.GetWorkspaceUsersSuccess
 */
export type GetWorkspaceUsersSuccess = Message<'com.gem.bff.contract.GetWorkspaceUsersSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.WorkspaceParticipant users = 1;
   */
  users: WorkspaceParticipant[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetWorkspaceUsersSuccess.
 * Use `create(GetWorkspaceUsersSuccessSchema)` to create a new message.
 */
export const GetWorkspaceUsersSuccessSchema: GenMessage<GetWorkspaceUsersSuccess> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_responses, 3);

/**
 * @generated from message com.gem.bff.contract.SearchUsersInWorkspaceResponse
 */
export type SearchUsersInWorkspaceResponse =
  Message<'com.gem.bff.contract.SearchUsersInWorkspaceResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SearchUsersInWorkspaceResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SearchUsersInWorkspaceSuccess success = 1;
           */
          value: SearchUsersInWorkspaceSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersInWorkspaceResponse.
 * Use `create(SearchUsersInWorkspaceResponseSchema)` to create a new message.
 */
export const SearchUsersInWorkspaceResponseSchema: GenMessage<SearchUsersInWorkspaceResponse> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_responses, 4);

/**
 * @generated from message com.gem.bff.contract.SearchUsersInWorkspaceSuccess
 */
export type SearchUsersInWorkspaceSuccess =
  Message<'com.gem.bff.contract.SearchUsersInWorkspaceSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.WorkspaceParticipant users = 1;
     */
    users: WorkspaceParticipant[];

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersInWorkspaceSuccess.
 * Use `create(SearchUsersInWorkspaceSuccessSchema)` to create a new message.
 */
export const SearchUsersInWorkspaceSuccessSchema: GenMessage<SearchUsersInWorkspaceSuccess> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_responses, 5);
